var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditReversal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 15.3336L13 12.6669L10.3333 10.0002M1 8.66699V10.0003C1 10.7076 1.28095 11.3858 1.78105 11.8859C2.28115 12.386 2.95942 12.667 3.66667 12.667H13M3.66675 0.666992L1.00008 3.33366L3.66675 6.00033M13 7.3335V6.00016C13 5.29292 12.719 4.61464 12.219 4.11454C11.7189 3.61445 11.0406 3.3335 10.3333 3.3335H1",
    stroke: "#212D41",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditReversal);
export default __webpack_public_path__ + "static/media/edit-reversal.eebd2723978e9526558df6cf6692d00e.svg";
export { ForwardRef as ReactComponent };